// This icon file is generated automatically.
var PVerticalAlignTopOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M11.44.63H.56a.13.13 0 00-.12.12v.94c0 .07.05.12.12.12h10.88c.07 0 .12-.05.12-.12V.75a.13.13 0 00-.12-.13zM6.1 3.54a.12.12 0 00-.2 0L4.15 5.76c-.06.08 0 .2.1.2H5.4v5.29c0 .07.06.13.13.13h.94c.07 0 .12-.06.12-.13V5.96h1.16c.1 0 .16-.12.1-.2L6.1 3.55z", "fill-rule": "nonzero" } }] }, "name": "p-vertical-align-top", "theme": "outlined" };
export default PVerticalAlignTopOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PVerticalAlignTopOutlined.js
// module id = 3727
// module chunks = 0